import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'aws-amplify/auth/enable-oauth-listener';
import {
  AllCommunityModule,
  ModuleRegistry,
  RowSelectionModule,
} from 'ag-grid-community';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';

import { TCreateAppRooParams } from '@/shared/utils/create-app-root/create-app-root.types';
import { initLogRocket } from '@/shared/utils/create-app-root/logrocket';
import {
  initSentry,
  reactErrorHandler,
} from '@/shared/utils/create-app-root/sentry';

ModuleRegistry.registerModules([AllCommunityModule, RowSelectionModule]);

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  weekStart: 0, // Sunday = 0, Monday = 1, etc.
});

export const createAppRoot = ({
  app,
  initializeSentry = true,
  initializeLogRocket = true,
}: TCreateAppRooParams) => {
  if (initializeSentry) {
    initSentry();
  }

  if (initializeLogRocket) {
    initLogRocket();
  }

  const root = document.getElementById('root');
  if (!root) {
    throw new Error('No root element found');
  }

  createRoot(root, {
    onUncaughtError: reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: reactErrorHandler(),
    onRecoverableError: reactErrorHandler(),
  }).render(app);
};
